/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  EnableAffiliateReferrerOptions,
  EnableAffiliateReferrerResponses,
} from '../types/EnableAffiliateReferrer'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Uses the same ADMIN, tenant INTEGRATOR, and assigned-program AFFILIATE_MANAGER permissions as disabling. Clears disabled_at and disabled_by on the existing membership, preserving its ID, user, program, codes, customization, and attribution history. Already enabled returns 200 unchanged. Unknown or wrong-program members return 404. Does not unpause the program or change independent signup, account, tenant, or campaign rules.
 * @summary Re-enable an existing referrer
 * {@link /v1/affiliate_programs/:program_id/referrers/:referrer_id/enable}
 */
export function enableAffiliateReferrer<ThrowOnError extends boolean = true>(
  options: Options<EnableAffiliateReferrerOptions, ThrowOnError>,
): Unwrappable<RequestResult<EnableAffiliateReferrerResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/affiliate_programs/{program_id}/referrers/{referrer_id}/enable',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<EnableAffiliateReferrerResponses, ThrowOnError>>,
  )
}
